import { render, staticRenderFns } from "./DealResults.vue?vue&type=template&id=5e055e2a&"
import script from "./DealResults.vue?vue&type=script&lang=js&"
export * from "./DealResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports